import { Box, Flex, IconButton, Image, Text } from "@chakra-ui/react"
import { FaBars } from "react-icons/fa"

import { useBranding } from "@/hooks/useBranding"

interface MobileBannerProps {
  compact?: boolean
  onMenuOpen: () => void
}

function MobileBanner({ compact = false, onMenuOpen }: MobileBannerProps) {
  const { display_name, logo_url } = useBranding()

  if (compact) {
    return (
      <Box display={{ base: "block", md: "none" }} px={3} py={2}>
        <IconButton
          variant="ghost"
          color="gray.700"
          aria-label="Open Menu"
          flexShrink={0}
          onClick={onMenuOpen}
        >
          <FaBars />
        </IconButton>
      </Box>
    )
  }

  return (
    <Box
      display={{ base: "block", md: "none" }}
      bg="bg.muted"
      color="fg"
      px={3}
      py={2.5}
      shadow="md"
    >
      <Flex align="center" gap={3}>
        <IconButton
          variant="ghost"
          color="gray.700"
          aria-label="Open Menu"
          flexShrink={0}
          onClick={onMenuOpen}
        >
          <FaBars />
        </IconButton>
        <Image
          src={logo_url}
          alt={display_name}
          maxH="50px"
          w="auto"
          objectFit="contain"
          flexShrink={0}
        />
        <Box flex={1} minW={0}>
          <Text fontWeight="bold" fontSize="md" color="fg" truncate>
            {display_name}
          </Text>
        </Box>
      </Flex>
    </Box>
  )
}

export default MobileBanner
